import React from "react"
import { Navbar, Nav } from "react-bootstrap"
import { Link } from "gatsby"
import LogoAdda from "../../../img/logo.png"

class NavNav extends React.Component {
  render() {
    return (
      <div className="sticky">
        <Navbar
          collapseOnSelect
          expand="lg"
          // variant="dark"
          style={{
            position: "sticky",
            width: "100%",
            background: "black",
            // height: "53px",
            zIndex: "1100",
            top: "0px",
            boxShadow: "0 2px 2px -2px rgba(0,0,0,.9)",
            // background: "transparent",
          }}
        >
          <Navbar.Brand style={{ marginLeft: "10%" }}>
            <Link to="/">
              <img
                src={LogoAdda}
                alt="Logo"
                width="80%"
                style={{ marginBottom: "0px" }}
              />
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle style={{ backgroundColor: "white" }} />
          <Navbar.Collapse
            style={{ justifyContent: "flex-end", marginRight: "7%" }}
          >
            <Nav.Item
              style={{
                fontFamily: "PSL-Kanda",
                color: "white",
                fontSize: "20px",
                marginRight: "20px",
              }}
            >
              <Link style={{ color: "white" }} to="/">
                HOME
              </Link>
            </Nav.Item>
            <Nav.Item
              style={{
                fontFamily: "PSL-Kanda",
                color: "white",
                fontSize: "20px",
                marginRight: "20px",
              }}
            >
              <Link
                style={{ color: "white" }}
                to="https://shop.adda.co.th/"
                target="_blank"
                rel="noopener noreferrer"
              >
                ADDA SHOP
              </Link>
            </Nav.Item>
            {/* <Nav.Item
              style={{
                fontFamily: "PSL-Kanda",
                color: "white",
                fontSize: "20px",
                marginRight: "20px",
              }}
            >
              <Link style={{ color: "white" }} to="/men">
                MEN
              </Link>
            </Nav.Item>
            <Nav.Item
              style={{
                fontFamily: "PSL-Kanda",
                color: "white",
                fontSize: "20px",
                marginRight: "20px",
              }}
            >
              <Link style={{ color: "white" }} to="/women">
                WOMEN
              </Link>
            </Nav.Item>
            <Nav.Item
              style={{
                fontFamily: "PSL-Kanda",
                color: "white",
                fontSize: "20px",
                marginRight: "20px",
              }}
            >
              <Link style={{ color: "white" }} to="/kids">
                KIDS
              </Link>
            </Nav.Item> */}
            <Nav.Item
              style={{
                fontFamily: "PSL-Kanda",
                color: "white",
                fontSize: "20px",
                marginRight: "20px",
              }}
            >
              <Link style={{ color: "white" }} to="/contact">
                CONTACT
              </Link>
            </Nav.Item>
            <Nav.Item
              style={{
                fontFamily: "PSL-Kanda",
                color: "white",
                fontSize: "20px",
                marginRight: "20px",
              }}
            >
              {/* <Link style={{ color: "white" }} to="/about-us">
                ABOUT US
              </Link> */}
            </Nav.Item>
          </Navbar.Collapse>
        </Navbar>
      </div>
    )
  }
}

export default NavNav
